import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@material-ui/core";
import NewFollowUp from "./NewFollowUp.js";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

export default () => {
    const classes = useStyles();
    const followUpDialogRef = useRef();
    const therapist = useSelector(state => state.data.therapist);

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Titel</TableCell>
                        <TableCell> Type af opfølgningsbesked</TableCell>
                        <TableCell align="right">Modtagelsestidspunkt i dage efter behandling</TableCell>
                        <TableCell align="right">Tilvalg af denne service</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow key={"handson"}>
                        <TableCell>
                            Opfølgningsbrev
                        </TableCell>
                        <TableCell>
                            Behandling
                        </TableCell>
                        <TableCell align="right">{therapist.followUpTime}</TableCell>
                        <TableCell align="right">{therapist.followUp ? "Ja" : "Nej"}</TableCell>
                        <TableCell align="right">
                            <NewFollowUp new={false} ref={followUpDialogRef} />
                            <Button
                                variant="contained"
                                onClick={() => {
                                    console.log(therapist);
                                    followUpDialogRef.current.editFollowUp(
                                        therapist.followUpText,
                                        therapist.followUpTime,
                                        therapist.followUp,
                                        "behandling"
                                    );
                                }}>
                                Rediger
                            </Button>
                        </TableCell>
                    </TableRow>
                    <TableRow key={"handsonKursus"}>
                        <TableCell>
                            Opfølgningsbrev
                        </TableCell>
                        <TableCell>
                            Kursus
                        </TableCell>
                        <TableCell align="right">{therapist.followUpTimeCourse}</TableCell>
                        <TableCell align="right">{therapist.followUpCourse ? "Ja" : "Nej"}</TableCell>
                        <TableCell align="right">
                            <NewFollowUp new={false} ref={followUpDialogRef} />
                            <Button
                                variant="contained"
                                onClick={() => {
                                    followUpDialogRef.current.editFollowUp(
                                        therapist.followUpTextCourse,
                                        therapist.followUpTimeCourse,
                                        therapist.followUpCourse,
                                        "kursus"
                                    );
                                }}>
                                Rediger
                            </Button>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};
